<template>
  <div>
    <ValidationObserver ref="validationObserver" v-slot="{ dirty }">
      <form
        action="#"
        v-on:submit.prevent="search"
        class="box-shadow search-trip-form d-flex flex-md-row align-items-center py-20 px-18"
        :class="formClass"
      >
        <airport-input
          ref="fromInput"
          input-id="from-input"
          v-model="searchForm.airportFrom"
          :selected-airport="searchForm.airportTo"
          :placeholder="fromPlaceholder"
          :show-error="showInvalidMessage"
          :validation-rules="getValidationRules"
          error-class="error-from"
          input-class="from-input d-md-flex flex-wrap align-items-center"
          :empty-label="''"
        ></airport-input>

        <button
          @click="toggleAirports"
          type="button"
          title="Toggle Airports"
          class="btn toggle-airports icon text-pearl px-6 py-0"
        >
          <i class="icon-refresh"></i>
        </button>

        <airport-input
          ref="toInput"
          input-id="to-input"
          v-model="searchForm.airportTo"
          :selected-airport="searchForm.airportFrom"
          :placeholder="toPlaceholder"
          :show-error="showInvalidMessage"
          :validation-rules="getValidationRules"
          error-class="mt-1"
          input-class="to-input mr-md-20 mr-xl-30"
        ></airport-input>

        <!-- <ValidationProvider v-slot="{ errors }" vid="search-date-range" :name="datePlaceholder.toLowerCase()"
        :rules="getValidationRules">-->
        <date-picker
          ref="searchDateRange"
          :input-class="'form-control date-picker text-left'"
          :editable="false"
          format="MM-DD-YYYY"
          class="form control date-rage-picker text-left pl-lg-10 pr-lg-35"
          v-model="searchForm.dateRange"
          value-type="format"
          range
          :placeholder="dateRangePlaceholder"
          :default-value="new Date().setHours(0, 0, 0, 0)"
          :disabled-date="isDateDisabled"
          @pick="restrictRange"
          @close="resetRestrictRange"
        >
          <template slot="input">
            <input
              type="text"
              :placeholder="dateRangePlaceholder"
              autocomplete="off"
              readonly="readonly"
              :value="dateRangeValue"
              class="form-control date-picker text-left"
            />
          </template>
        </date-picker>
        <!-- <div v-if="errors.length > 0" class="position-absolute mt-0 ml-5 invalid-feedback">{{ errors[0] }}
                    </div>
        </ValidationProvider>-->

                <button id="search-flight" :disabled="!dirty || disableSearchButton" class="btn btn-primary">Search</button>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import DatePickerMixin from '../../../mixins/datePickerMixin';
    import AirportTemplate from '../Templates/AirportTemplate';
    import AirportInput from './Inputs/AirportInput';
    import moment from 'moment';

export default {
  props: {
    searchForm: {
      required: true,
      type: Object
    },
    fromPlaceholder: {
      type: String,
      default: "From"
    },
    toPlaceholder: {
      type: String,
      default: "To"
    },
    datePlaceholder: {
      type: String,
      default: "Fill in Date Range"
    },
    showInvalidMessage: {
      default: false,
      type: Boolean
    },
    showValidationMessage: {
      default: false,
      type: Boolean
    },
    formClass: {
      default: null,
      type: [String, Object]
    }
  },
  mixins: [DatePickerMixin],
  components: {
    DatePicker,
    AirportInput
  },
  data() {
    return {
      template: AirportTemplate,
      invalidFrom: false,
      invalidTo: false,
      firstDateSelect: null
    };
  },
  computed: {
    disableSearchButton() {
      let numberOfFieldsSelected = 0;
      if (this.$refs.fromInput.value) {
        numberOfFieldsSelected++
      }
      if (this.$refs.toInput.value) {
        numberOfFieldsSelected++
      }
      if (this.searchForm.dateRange && this.searchForm.dateRange[0]) {
        numberOfFieldsSelected++
      }
      return  numberOfFieldsSelected < 2 ;
    },
    isAdmin() {
      return (
        this.$store.state.auth &&
        this.$store.state.users.user.role.name === "admin"
      );
    },
    getValidationRules() {
      /* if (this.isAdmin) {
        return null;
      }
      return "required"; */
      return null
    },
    allowedRangeFrom() {
      if (this.firstDateSelect) {
        const rangeFrom = new Date(this.firstDateSelect.getTime());
        return new Date(rangeFrom.setDate(rangeFrom.getDate() - 31));
      }
      return null;
    },
    allowedRangeTo() {
      if (this.firstDateSelect) {
        const rangeTo = new Date(this.firstDateSelect.getTime());
        return new Date(rangeTo.setDate(rangeTo.getDate() + 31));
      }
      return null;
    },

    dateRangePlaceholder() {
      if (this.firstDateSelect) {
        return `${this.firstDateSelect.toISOString().substring(0, 10)} ~`;
      }
      return this.datePlaceholder;
    },
    dateRangeValue() {
      if (this.firstDateSelect) {
        return `${moment(this.firstDateSelect).format("MM-DD-YYYY")} ~`;
      }
      if (this.searchForm.dateRange && this.searchForm.dateRange[0]) {
        return `${this.searchForm.dateRange[0]} ~ ${this.searchForm.dateRange[1]}`;
      }
      return null;
    }
  },
  watch: {
    "searchForm.dateRange": {
      handler() {
        this.resetRestrictRange();
      }
    }
  },
  methods: {
    search() {
      this.$emit("search");
    },
    beforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    isDateDisabled(date) {
      if (this.beforeToday(date)) {
        return true;
      }
      if (this.firstDateSelect) {
        // check 14 days before and 14 days after
        if (date > this.allowedRangeFrom && date < this.allowedRangeTo) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    restrictRange(date) {
      if (!this.firstDateSelect) {
        // firstDateSelect is null
        this.firstDateSelect = date;
      } else {
        // firstDateSelect selected
        this.firstDateSelect = null;
      }
    },
    resetRestrictRange() {
      this.firstDateSelect = null;
    },
    toggleAirports() {
      const fromInput = this.$refs.fromInput.getCopy();
      const toInput = this.$refs.toInput.getCopy();

      this.searchForm.airportFrom = toInput.airport;
      this.searchForm.airportTo = fromInput.airport;

      this.$refs.fromInput.setValue(toInput);
      this.$refs.toInput.setValue(fromInput);
    },
    clear() {
      this.$refs.toInput.clear();
      this.$refs.fromInput.clear();
      this.$refs.validationObserver.reset();
    }
  }
};
</script>
